import React from "react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "react-query";

import {
  ContactRequest,
  ContactService,
} from "pages/contact-us/contact-us.service";
import {
  Button,
  Form,
  InputField,
  SelectField,
  TextArea,
} from "components/form";
import { json, validatePhone } from "helpers/data";
import { EmailPattern, lettersOnly } from "helpers/patterns";
import { InfoService } from "pages/informations/info.service";

export default function ContactForm() {
  const { t } = useTranslation("contact-us");
  const { data: helpOptions = [] } = useQuery(
    "help-options",
    ContactService.getHelpOptions
  );
  const { data: industryFields = [] } = useQuery(
    "industry-fields",
    InfoService.getIndustryFields
  );
  const { data: countries = [] } = useQuery(
    "countries",
    InfoService.getCountries
  );
  const { data: companySizes = [] } = useQuery(
    "company-sizes",
    InfoService.getCompanySizes
  );

  const createRequest = useMutation(ContactService.createContactRequest);
  const { isLoading } = createRequest;

  function renderRequiredLabel(label: string) {
    return label;
    // return (
    //   <span>
    //     {label}
    //     <i className="red-star">*</i>:{" "}
    //   </span>
    // );
  }

  const handleSubmit = (data: ContactRequest) => {
    const country = countries.find((c) => c.id === +data.country);

    const dto = {
      ...data,
      country: json(country!.name),
      helpMessage: json(data.helpMessage),
      industry: json(data.industry),
      mobileNumber: country!.phoneCode + data.mobileNumber,
    };

    createRequest.mutate(dto, {
      onSuccess() {
        toast.success(t("sent-success"));
      },
    });
  };

  return (
    <Form
      className="contact-form"
      defaultValues={{
        helpMessage: "",
        companySize: "",
        industry: "",
        country: "",
      }}
      onSubmit={handleSubmit}
    >
      {({ watch }) => {
        return (
          <>
            <h2>{t("form.title")}</h2>
            <SelectField
              valueField="name"
              label={renderRequiredLabel(t("form.helpField"))}
              id="helpMessage"
              options={helpOptions}
              labelField="name"
              rules={{ required: "errors:required" }}
            />

            <InputField
              label={renderRequiredLabel(t("form.fullName"))}
              id="fullName"
              rules={{
                required: "errors:required",
                pattern: { value: lettersOnly, message: "errors:invalid" },
              }}
            />
            <SelectField
              valueField="id"
              label={t("form.country")}
              id="country"
              options={countries}
              labelField="name"
            />
            <div className="row">
              <div className="col-3">
                <SelectField
                  label={renderRequiredLabel(t("form.code"))}
                  id="country"
                  options={countries}
                  labelField="phoneCode"
                  valueField="id"
                  rules={{ required: "errors:required" }}
                />
              </div>
              <div className="col-9">
                <InputField
                  label={renderRequiredLabel(t("form.mobileNumber"))}
                  id="mobileNumber"
                  rules={{
                    required: "errors:required",
                    validate: () =>
                      !!validatePhone(
                        watch("mobileNumber"),
                        countries.find((c) => c.id === watch("country"))
                          ?.phoneCode ?? "20"
                      ) || "Invalid Phone Number",
                  }}
                />
              </div>
            </div>
            <InputField
              label={renderRequiredLabel(t("form.email"))}
              id="fromEmail"
              rules={{
                required: "errors:required",
                pattern: {
                  value: EmailPattern,
                  message: "errors:invalidFormat",
                },
              }}
            />
            <InputField label={t("form.companyName")} id="companyName" />
            <div className="row">
              <div className="col-6">
                <SelectField
                  valueField="name"
                  label={t("form.field")}
                  id="industry"
                  options={industryFields}
                  labelField="name"
                />
              </div>
              <div className="col-6">
                <SelectField
                  valueField="name"
                  label={t("form.companySize")}
                  id="companySize"
                  options={companySizes}
                  labelField="name"
                />
              </div>
            </div>
            <TextArea
              label={t("form.message")}
              id="message"
              rules={{ required: "errors:required" }}
            />
            <Button isLoading={isLoading} className="btn-blue">
              {t("form.send")}
            </Button>
          </>
        );
      }}
    </Form>
  );
}
